/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
// Core
import { ControlComponent } from '../../core/component/control.component';
// JQX Widget
import { jqxDataTableComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxdatatable';

/**
 * Data Table
 */
@Component({
    selector: 'ngc-datatable',
    template: `<jqxDataTable *ngIf="visible"
                [altRows] = "altRows"
                [autoRowHeight] = "autoRowHeight"
                [aggregatesHeight] = "aggregatesHeight"
                [autoShowLoadElement] = "autoShowLoadElement"
                [columnsHeight] = "columnsHeight"
                [columns] = "columns"
                [columnGroups] = "columnGroups"
                [columnsResize] = "columnsResize"
                [columnsReorder] = "columnsReorder"
                [disabled] = "disabled"
                [editable] = "editable"
                [editSettings] = "editSettings"
                [exportSettings] = "exportSettings"
                [enableHover] = "enableHover"
                [enableBrowserSelection] = "enableBrowserSelection"
                [filterable] = "filterable"
                [filterHeight] = "filterHeight"
                [filterMode] = "filterMode"
                [groups] = "groups"
                [groupsRenderer] = "groupsRenderer"
                [initRowDetails] = "initRowDetails"
                [incrementalSearch] = "incrementalSearch"
                [localization] = "localization"
                [pagerHeight] = "pagerHeight"
                [pageSize] = "pageSize"
                [pageSizeOptions] = "pageSizeOptions"
                [pageable] = "pageable"
                [pagerPosition] = "pagerPosition"
                [pagerMode] = "pagerMode"
                [pagerButtonsCount] = "pagerButtonsCount"
                [pagerRenderer] = "pagerRenderer"
                [ready] = "ready"
                [rowDetails] = "rowDetails"
                [renderToolbar] = "renderToolbar"
                [renderStatusbar] = "renderStatusbar"
                [rendering] = "rendering"
                [rendered] = "rendered"
                [rtl] = "rtl"
                [source] = "source"
                [sortable] = "sortable"
                [showAggregates] = "showAggregates"
                [showToolbar] = "showToolbar"
                [showStatusbar] = "showStatusbar"
                [statusBarHeight] = "statusBarHeight"
                [scrollBarSize] = "scrollBarSize"
                [selectionMode] = "selectionMode"
                [serverProcessing] = "serverProcessing"
                [showHeader] = "showHeader"
                [theme] = "theme"
                [toolbarHeight] = "toolbarHeight"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxDataTable>`
})
export class NgcDataTableComponent extends ControlComponent {
    @Input('altRows') altRows: any;
    @Input('autoRowHeight') autoRowHeight: any;
    @Input('aggregatesHeight') aggregatesHeight: any;
    @Input('autoShowLoadElement') autoShowLoadElement: any;
    @Input('columnsHeight') columnsHeight: any;
    @Input('columns') columns: any;
    @Input('columnGroups') columnGroups: any;
    @Input('columnsResize') columnsResize: any;
    @Input('columnsReorder') columnsReorder: any;
    @Input('editable') editable: any;
    @Input('editSettings') editSettings: any;
    @Input('exportSettings') exportSettings: any;
    @Input('enableHover') enableHover: any;
    @Input('enableBrowserSelection') enableBrowserSelection: any;
    @Input('filterable') filterable: any;
    @Input('filterHeight') filterHeight: any;
    @Input('filterMode') filterMode: any;
    @Input('groups') groups: any;
    @Input('groupsRenderer') groupsRenderer: any;
    @Input('initRowDetails') initRowDetails: any;
    @Input('incrementalSearch') incrementalSearch: any;
    @Input('localization') localization: any;
    @Input('pagerHeight') pagerHeight: any;
    @Input('pageSize') pageSize: any;
    @Input('pageSizeOptions') pageSizeOptions: any;
    @Input('pageable') pageable: any;
    @Input('pagerPosition') pagerPosition: any;
    @Input('pagerMode') pagerMode: any;
    @Input('pagerButtonsCount') pagerButtonsCount: any;
    @Input('pagerRenderer') pagerRenderer: any;
    @Input('ready') ready: any;
    @Input('rowDetails') rowDetails: any;
    @Input('renderToolbar') renderToolbar: any;
    @Input('renderStatusbar') renderStatusbar: any;
    @Input('rendering') rendering: any;
    @Input('rendered') rendered: any;
    @Input('rtl') rtl: any;
    @Input('source') source: any;
    @Input('sortable') sortable: any;
    @Input('showAggregates') showAggregates: any;
    @Input('showToolbar') showToolbar: any;
    @Input('showStatusbar') showStatusbar: any;
    @Input('statusBarHeight') statusBarHeight: any;
    @Input('scrollBarSize') scrollBarSize: any;
    @Input('selectionMode') selectionMode: any;
    @Input('serverProcessing') serverProcessing: any;
    @Input('showHeader') showHeader: any;
    @Input('theme') theme: any;
    @Input('toolbarHeight') toolbarHeight: any;
    @Input('width') width: any;
    @Input('height') height: any;
    @Input('auto-create') autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }
}

/**
 * Data Table Module
 */
@NgModule({
    imports: [CommonModule],
    exports: [NgcDataTableComponent],
    declarations: [NgcDataTableComponent, jqxDataTableComponent]
})
export class NgcDataTableModule {
}